import { query ,frameWorkTwoQuery} from "./query"

export const frameWorkQuery = {
  query,
  frameWorkTwoQuery,
  mocks: {
    defaultData: null,
  },
}
